/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2020] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');
var Marionette = require('backbone.marionette');
var Ladda = require('ladda');
var Radio = require('backbone.radio');

var modelGet = require('common/util/modelGet');
var BreadcrumbView = require('common/views/BreadcrumbView');
var momentUtil = require('common/util/momentUtil');

var SubmitEntityDirector = require('../services/SubmitEntityDirector');
var DepDirectorFormView = require('./DepDirectorFormView');

var tmplDepDirectorNewView = require('../templates/DepDirectorNewView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplDepDirectorNewView,

  className: 'dep-director-new-view container-fluid',

  ui: {
    breadcrumb: '.breadcrumb-container',
    directorContainer: '.director-form-container',
    submit: '.submit'
  },

  regions: {
    breadcrumb: '@ui.breadcrumb',
    directorContainer: '@ui.directorContainer'
  },

  events: {
    'click @ui.submit': 'onClickSubmit'
  },

  templateHelpers: function() {
    var isCUTrustHC = _.contains(['11', '21', '22'], modelGet(this.model, 'entityIdentifiers.entityTypeId'));
    return {
      isCUTrustHC: isCUTrustHC
    };
  },

  onBeforeShow: function() {
    var entityId = this.model.get('entityId');
    var entityName = modelGet(this.model, 'entityIdentifiers.entityName');
    var isCUTrustHC = _.contains(['11', '21', '22'], modelGet(this.model, 'entityIdentifiers.entityTypeId'));

    this.showChildView(
      'breadcrumb',
      new BreadcrumbView({
        breadcrumbs: [
          {
            link: '#dep/dashboard',
            text: 'Home'
          },
          {
            link: '#dep/entity/' + entityId + '/dashboard',
            text: entityName
          },
          {
            text: isCUTrustHC ? 'New Director' : 'New Director-Trustee'
          }
        ]
      })
    );
    this.directorForm = new DepDirectorFormView({
      model: this.model
    });
    this.showChildView('directorContainer', this.directorForm);
  },

  onClickSubmit: function(e) {
    e.preventDefault();
    var self = this;
    var entityId = this.model.get('entityId');

    this.validate().done(function() {
      var l = Ladda.create(self.ui.submit[0]);
      l.start();
      var formData = self.getFormData();
      SubmitEntityDirector(formData)
        .done(function(directorId) {
          Radio.channel('navigate').trigger('show:int:dp:director', entityId, directorId);
        })
        .fail(function() {
          l.stop();
        });
    });
  },

  getFormData: function() {
    var formData = this.directorForm.getFormData();

    formData.entityId = this.model.get('entityId');

    formData.termStartDate = momentUtil.formatStr(formData.termStartDate, momentUtil.defaultOutboundDateConfig);
    formData.termEndDate = momentUtil.formatStr(formData.termEndDate, momentUtil.defaultOutboundDateConfig);
    formData.electionDate = momentUtil.formatStr(formData.electionDate, momentUtil.defaultOutboundDateConfig);
    return formData;
  },

  validate: function() {
    return this.ui.directorContainer.parsley().whenValidate();
  }
});
